import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { List, X, SignOut, User } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";
import BrandMark from "./BrandMark";

const NAV = [
  { to: "/countries", label: "Countries" },
  { to: "/compare", label: "Compare" },
  { to: "/services", label: "Services" },
  { to: "/calculator", label: "Calculator" },
  { to: "/franchise", label: "Franchise" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/blog", label: "Insights" },
];

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 border-b border-black/5 backdrop-blur-xl"
      style={{ background: "rgba(248, 246, 240, 0.82)" }}
    >
      <div className="container-gos flex items-center justify-between py-4">
        <BrandMark testid="logo-home-link" />

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to} to={n.to}
              data-testid={`nav-${n.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm transition-colors ${isActive ? "text-gos-navy" : "text-gos-slate hover:text-gos-navy"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <Link to={user.role === "client" ? "/portal" : "/admin"} className="btn-secondary !py-2 !px-4 text-xs" data-testid="header-portal-link">
                <User size={14} weight="bold" /> {user.role === "client" ? "Portal" : "Admin"}
              </Link>
              <button onClick={() => { logout(); navigate("/"); }} data-testid="header-logout-btn" className="text-gos-slate hover:text-gos-navy">
                <SignOut size={18} />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link" className="text-sm text-gos-slate hover:text-gos-navy">Sign in</Link>
              <Link to="/contact" data-testid="header-consultation-btn" className="btn-primary !py-2 !px-4 text-xs">
                Book Consultation
              </Link>
            </>
          )}
        </div>

        <button data-testid="mobile-menu-toggle" className="lg:hidden text-gos-navy" onClick={() => setOpen((o) => !o)}>
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gos-border bg-gos-bone">
          <div className="container-gos py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`mobile-nav-${n.to.replace("/", "")}`}
                onClick={() => setOpen(false)}
                className="text-sm text-gos-slate hover:text-gos-navy">{n.label}</Link>
            ))}
            <div className="border-t border-gos-border pt-3 flex flex-col gap-2">
              {user ? (
                <>
                  <Link to={user.role === "client" ? "/portal" : "/admin"} onClick={() => setOpen(false)} className="btn-secondary !py-2 text-xs">
                    {user.role === "client" ? "Client Portal" : "Admin Panel"}
                  </Link>
                  <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="btn-secondary !py-2 text-xs">Sign out</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="btn-secondary !py-2 text-xs">Sign in</Link>
                  <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary !py-2 text-xs">Book Consultation</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
